import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

interface VideoProps {
  display: string;
}

export const StyledSection = styled(Section)`
  background: #ffffff !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-weight: 500;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 60px;
    font-weight: 500;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}
`;

export const Text = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 24px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.48px;
  `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
  margin: 24px 0px 0px;

  ${media.md`
    margin: 40px 0px 0px;
  `}

  ${media.xl`
    flex-direction: row;
    margin: 50px 0px 0px;
  `}
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffe2c8;
  width: 100%;
  height: 260px;
  border-radius: 16px;

  ${media.md`
    height: 580px;
  `}

  ${media.xl`
    width: calc(50% - 10px);
    height: 400px;
  `}
`;

export const ImageWrapper = styled.div`
  width: 148px;
  height: 210px;

  ${media.md`
    width: 345px;
    height: 496px;
  `}

  ${media.md`
    width: 220px;
    height: 320px;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Video = styled.video<VideoProps>`
  display: ${props => props.display || 'block'};
  width: 148px;
  height: 210px;

  ${media.md`
    width: 345px;
    height: 496px;
  `}

  ${media.md`
    width: 220px;
    height: 320px;
  `}
`;

export const ContentSection = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  gap: 16px;

  ${media.md`
    display: flex;
  `}

  ${media.xl`
    width: calc(50% - 10px);
    height: 400px;
  `}
`;


export const CardContainer = styled.div`
  background: #f0f0f5;
  display: flex;
  align-items: center;
  width: calc(100% - 32px);
  height: auto;
  padding: 16px;
  border-radius: 16px;
  gap: 25px;

  ${media.md`
    height: 70.8px;
  `}

  ${media.xl`
    height: 90.8px;
  `}
`;

export const CardImageWrapper = styled.div`
  width: 48px;
  height: 48px;

  ${media.md`
    width: 60px;
    height: 60px;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CardContentContanier = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CardTitle = styled.h3`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 23px;
  font-weight: 500;
  line-height: 85%;
  letter-spacing: -0.46px;
  text-transform: uppercase;
  margin: 0px;
`;

export const CardText = styled.p`
  color: #67656e;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.28px;
  margin: 0px;

  ${media.md`
    font-size: 16px;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: -0.28px;
  `}
`;

export const ContentSectionMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  gap: 16px;

  ${media.md`
    display: none;
  `}
`;

export const CardContainerMobile = styled.div`
  background: #f0f0f5;
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  height: auto;
  padding: 16px;
  border-radius: 16px;
  gap: 16px;
`;

export const CardContentContanierMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
